import iconPathCalendarRecurring from 'raw-loader!@/assets/icon-path-calendar-recurring.txt';
import iconPathCardGroup from 'raw-loader!@/assets/icon-path-card-group.txt';
import iconPathCardPersonal from 'raw-loader!@/assets/icon-path-card-personal.txt';
import iconPathCardInvitation from 'raw-loader!@/assets/icon-path-card-invitation.txt';
import { mdiVideoVintage, mdiWalletGiftcard, mdiDomain, mdiEmailMultiple, mdiCalendarStart, mdiPencilRuler } from '@mdi/js';


const ACTIONS = [
  [ { name: 'catalog-category', params: { category: 'greeting-cards' }, hash: '#search' }, 'Send a card', iconPathCardPersonal ],
  [ { name: 'catalog-category', params: { category: 'group-cards' }, hash: '#search' }, 'Send a group card', iconPathCardGroup ],
  [ { name: 'catalog-category', params: { category: 'invitations' }, hash: '#search' }, 'Send an invitation', iconPathCardInvitation ],
  [ { name: 'catalog-gift-cards' }, 'Send a gift card', mdiWalletGiftcard ],
  [ { name: 'catalog-video' }, 'Make a group video', mdiVideoVintage ],
  [ { name: 'automation' }, 'Schedule automated cards', iconPathCalendarRecurring ],
  [ { name: 'batch-order' }, 'Place a bulk order', mdiCalendarStart ],
  [ { name: 'bulk-email' }, 'Send a mass-email', mdiEmailMultiple ],
  // [ { name: 'design' }, 'Create a card design', mdiPencilRuler ],
  [ { name: 'account-org' }, 'Set up an organization', mdiDomain ]
];


export { ACTIONS };
